(function () {
  /**
   * RUSHnGO menu drawer — bag-identical open/close motion, top→bottom axis.
   * Duration: 900ms (slightly longer than bag’s 700ms). Same easing.
   * Scroll lock mirrors the bag (events only) — never overflow:hidden on html/body.
   */
  var DRAWER_MS = 900;
  var PORTAL_ID = 'rn-menu-drawer-portal';
  var DETAILS_ID = 'Details-menu-drawer-container';
  var DESKTOP_MQ = '(min-width: 990px)';

  var state = {
    closing: false,
    closeTimer: null,
    closeTransitionHandler: null,
    ignoreCloseUntil: 0,
    scrollGuardsBound: false,
    warmed: false,
    pointerHandledUntil: 0,
    postOpenTimer: null,
  }

  function getPortal() {
    return document.getElementById(PORTAL_ID);
  }

  function getHeaderDrawer() {
    return document.querySelector('header-drawer.rn-menu');
  }

  function getDetails() {
    return document.getElementById(DETAILS_ID);
  }

  function getPanel() {
    var portal = getPortal();
    return portal ? portal.querySelector('.drawer__inner') : null;
  }

  function getSectionHeader() {
    return document.querySelector('.section-header');
  }

  function getStickyHeaderEl() {
    return document.querySelector('sticky-header');
  }

  function isDesktopMenu() {
    var drawer = getHeaderDrawer();
    if (!drawer) return false;
    if (drawer.getAttribute('data-breakpoint') === 'desktop') return false;
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function pinStickyHeader() {
    var header = getSectionHeader();
    var sticky = getStickyHeaderEl();
    if (header) {
      header.classList.remove('shopify-section-header-hidden');
      header.classList.add('shopify-section-header-sticky', 'menu-open');
    }
    if (sticky) {
      sticky.preventHide = true;
      sticky.preventReveal = false;
    }
  }

  function unpinStickyHeader() {
    var header = getSectionHeader();
    var sticky = getStickyHeaderEl();
    if (header) {
      header.classList.remove('menu-open');
    }
    if (sticky) {
      sticky.preventHide = false;
      sticky.preventReveal = false;
      sticky.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    }
  }

  function measureHeaderOffset() {
    var portal = getPortal();
    if (!portal) return;
    var header =
      document.querySelector('sticky-header.header-wrapper') ||
      document.querySelector('.header-wrapper') ||
      getSectionHeader();
    var top = 60;
    if (header) {
      var rect = header.getBoundingClientRect();
      if (rect.bottom > 1) top = Math.round(rect.bottom);
      else top = Math.round(header.offsetHeight || rect.height || 60);
    }
    portal.style.setProperty('--rn-menu-top', Math.max(0, top) + 'px');
  }

  function ensurePortal() {
    var portal = getPortal();
    if (!portal) {
      portal = document.createElement('div');
      portal.id = PORTAL_ID;
      portal.className = 'rn-menu-portal';
      portal.setAttribute('aria-hidden', 'true');
      document.body.appendChild(portal);
    }
    portal.removeAttribute('hidden');
    return portal;
  }

  function ensurePortaled() {
    var menu = document.getElementById('menu-drawer');
    if (!menu) return null;
    var portal = ensurePortal();
    if (menu.parentNode !== portal) portal.appendChild(menu);
    return menu;
  }

  function isOpen() {
    var portal = getPortal();
    return !!(portal && (portal.classList.contains('is-open') || portal.classList.contains('is-opening')));
  }

  function isInsidePanel(target) {
    var panel = getPanel();
    return !!(panel && target && panel.contains(target));
  }

  function onDocumentTouchMove(e) {
    if (!isOpen()) return;
    if (isInsidePanel(e.target)) return;
    e.preventDefault();
  }

  function onDocumentWheel(e) {
    if (!isOpen()) return;
    if (isInsidePanel(e.target)) return;
    e.preventDefault();
  }

  function lockPageScroll() {
    if (state.scrollGuardsBound) return;
    state.scrollGuardsBound = true;
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
    document.documentElement.classList.remove('rn-menu-scroll-lock');
    document.addEventListener('touchmove', onDocumentTouchMove, { passive: false });
    document.addEventListener('wheel', onDocumentWheel, { passive: false });
  }

  function unlockPageScroll() {
    if (!state.scrollGuardsBound) return;
    state.scrollGuardsBound = false;
    document.removeEventListener('touchmove', onDocumentTouchMove);
    document.removeEventListener('wheel', onDocumentWheel);
    document.documentElement.classList.remove('rn-menu-scroll-lock');
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
  }

  function setMenuOpenClass(open) {
    document.documentElement.classList.toggle('rn-menu-open', !!open);
    document.documentElement.classList.remove('rn-menu-scroll-lock');
  }

  function resetMenuPortalSafe() {
    var portal = getPortal();
    if (portal) {
      portal.classList.remove('is-open', 'is-opening', 'is-closing');
      portal.setAttribute('aria-hidden', 'true');
    }
    document.documentElement.classList.remove('rn-menu-open', 'rn-menu-scroll-lock');
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
    unlockPageScroll();
    unpinStickyHeader();
    state.closing = false;
    clearCloseTimer();
    clearPostOpenTimer();
    clearCloseTransitionHandler();
  }

  function clearCloseTimer() {
    if (state.closeTimer) {
      clearTimeout(state.closeTimer);
      state.closeTimer = null;
    }
  }

  function clearPostOpenTimer() {
    if (state.postOpenTimer) {
      clearTimeout(state.postOpenTimer);
      state.postOpenTimer = null;
    }
  }

  function clearCloseTransitionHandler() {
    var panel = getPanel();
    if (panel && state.closeTransitionHandler) {
      panel.removeEventListener('transitionend', state.closeTransitionHandler);
      state.closeTransitionHandler = null;
    }
  }

  function syncDetailsOpen(open) {
    var details = getDetails();
    var summary = details ? details.querySelector('summary') : null;
    if (!details) return;
    if (open) {
      details.setAttribute('open', '');
      details.classList.add('menu-opening');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    } else {
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }
  }

  function resetAccordions() {
    var menu = document.getElementById('menu-drawer');
    if (!menu) return;
    menu.querySelectorAll('[data-rn-accordion-toggle]').forEach(function (btn) {
      btn.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      var panel = btn.getAttribute('aria-controls')
        ? document.getElementById(btn.getAttribute('aria-controls'))
        : null;
      if (panel) panel.hidden = true;
    });
  }

  function toggleAccordion(btn) {
    if (!btn) return;
    var panelId = btn.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;
    var willOpen = !btn.classList.contains('is-open');
    btn.classList.toggle('is-open', willOpen);
    btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (panel) panel.hidden = !willOpen;
  }

  function openDrawer() {
    if (isDesktopMenu()) return;
    ensurePortaled();
    var portal = getPortal();
    var panel = getPanel();
    if (!portal || !panel) return;

    if (state.closing) {
      state.closing = false;
      clearCloseTimer();
      clearCloseTransitionHandler();
      portal.classList.remove('is-closing');
    }

    if (portal.classList.contains('is-open') || portal.classList.contains('is-opening')) return;

    state.closing = false;
    clearCloseTransitionHandler();
    clearPostOpenTimer();

    // Unhide sticky header BEFORE measuring — otherwise portal top becomes 0
    // and the header stays off-screen after a prior scroll.
    pinStickyHeader();
    measureHeaderOffset();
    setMenuOpenClass(true);
    syncDetailsOpen(true);

    // Bag-identical open sequence: is-opening → double-rAF → is-open
    portal.setAttribute('aria-hidden', 'false');
    portal.classList.remove('is-closing', 'is-open');
    portal.classList.add('is-opening');

    window.requestAnimationFrame(function () {
      void panel.offsetWidth;
      window.requestAnimationFrame(function () {
        if (state.closing) return;
        portal.classList.add('is-open');
        portal.classList.remove('is-opening');
      });
    });

    lockPageScroll();
  }

  function closeDrawer() {
    var portal = getPortal();
    var panel = getPanel();
    if (!portal || !panel) return;
    if ((!portal.classList.contains('is-open') && !portal.classList.contains('is-opening')) || state.closing) {
      return;
    }

    state.closing = true;
    clearCloseTimer();
    clearCloseTransitionHandler();
    clearPostOpenTimer();

    portal.classList.remove('is-open', 'is-opening');
    portal.classList.add('is-closing');
    setMenuOpenClass(false);
    unlockPageScroll();
    unpinStickyHeader();

    if (typeof removeTrapFocus === 'function') {
      try {
        removeTrapFocus();
      } catch (e) {}
    }

    var finished = false;
    function finishClose() {
      if (finished) return;
      finished = true;
      state.closing = false;
      clearCloseTimer();
      clearCloseTransitionHandler();
      portal.classList.remove('is-closing', 'is-opening');
      portal.setAttribute('aria-hidden', 'true');
      resetAccordions();
      syncDetailsOpen(false);
    }

    state.closeTransitionHandler = function (e) {
      if (e.target === panel && e.propertyName === 'transform') finishClose();
    };
    panel.addEventListener('transitionend', state.closeTransitionHandler);
    state.closeTimer = window.setTimeout(finishClose, DRAWER_MS + 50);
  }

  function toggleDrawer() {
    if (isDesktopMenu()) return;
    if (isOpen() || state.closing) closeDrawer();
    else openDrawer();
  }

  function resolveHref(link) {
    return link ? link.href || link.getAttribute('href') || '' : '';
  }

  function isNavLink(link, menu) {
    if (!link || !menu || !menu.contains(link)) return false;
    if (link.closest('[data-drawer-close]')) return false;
    var href = link.getAttribute('href');
    return !!(href && href !== '#' && href.indexOf('javascript:') !== 0);
  }

  function onKeyDown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      e.preventDefault();
      closeDrawer();
    }
  }

  function isMenuTrigger(target) {
    var drawer = getHeaderDrawer();
    if (!drawer || !target) return null;
    var mainSummary = target.closest('summary.header__icon--menu, button.rn-menu-trigger');
    if (mainSummary && drawer.contains(mainSummary)) return mainSummary;
    return null;
  }

  function bindCaptureController() {
    if (document.documentElement.dataset.rnMenuCapture === '1') return;
    document.documentElement.dataset.rnMenuCapture = '1';

    document.addEventListener(
      'pointerdown',
      function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        var trigger = isMenuTrigger(event.target);
        if (!trigger) return;
        if (isDesktopMenu()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        state.pointerHandledUntil = Date.now() + 700;
        toggleDrawer();
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var trigger = isMenuTrigger(event.target);
        if (trigger) {
          if (isDesktopMenu()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (Date.now() < state.pointerHandledUntil) return;
          toggleDrawer();
          return;
        }

        var menu = document.getElementById('menu-drawer');
        if (!menu || !menu.contains(event.target)) return;

        if (event.target.closest('.menu-drawer__overlay')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          closeDrawer();
          return;
        }

        var accordionBtn = event.target.closest('[data-rn-accordion-toggle]');
        if (accordionBtn && menu.contains(accordionBtn)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          toggleAccordion(accordionBtn);
          return;
        }

        var link = event.target.closest('a[href]');
        if (!isNavLink(link, menu)) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (link.target && link.target !== '_self') return;
        var href = (link.getAttribute('href') || '').toLowerCase();
        if (href.indexOf('/account') !== -1) return;
        state.ignoreCloseUntil = Date.now() + 1200;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.href = resolveHref(link);
      },
      true
    );

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      onKeyDown(e);
    });

    window.addEventListener(
      'resize',
      function () {
        if (isOpen()) measureHeaderOffset();
        if (isDesktopMenu() && isOpen()) closeDrawer();
      },
      { passive: true }
    );
  }

  function neutralizeDawn() {
    var MenuDrawer = window.customElements && customElements.get('menu-drawer');
    var HeaderDrawer = window.customElements && customElements.get('header-drawer');
    if (MenuDrawer && !MenuDrawer.prototype.__rnMenuDrawerPatched) {
      MenuDrawer.prototype.__rnMenuDrawerPatched = true;
      var origFocusOut = MenuDrawer.prototype.onFocusOut;
      MenuDrawer.prototype.onFocusOut = function (event) {
        if (this.classList.contains('rn-menu') && isOpen()) return;
        return origFocusOut.call(this, event);
      };
      MenuDrawer.prototype.closeAnimation = function () {};
    }
    if (HeaderDrawer && !HeaderDrawer.prototype.__rnMenuPatched) {
      HeaderDrawer.prototype.__rnMenuPatched = true;
      HeaderDrawer.prototype.openMenuDrawer = function () {
        openDrawer();
      };
      HeaderDrawer.prototype.closeMenuDrawer = function (event) {
        if (event == null && isOpen()) return;
        if (Date.now() < state.ignoreCloseUntil) return;
        closeDrawer();
      };
      HeaderDrawer.prototype.closeButtonClick = function (event) {
        event.preventDefault();
        closeDrawer();
      };
    }
  }

  function warmCircleImages() {
    var portal = getPortal();
    var panel = getPanel();
    if (!portal || !panel) return;

    // Materialize hidden portal so eager images can decode before first open.
    portal.classList.add('rn-menu-warming');
    void panel.offsetWidth;

    var imgs = panel.querySelectorAll('img.rn-nav__circle-img');
    var left = imgs.length;
    function finish() {
      left -= 1;
      if (left <= 0) portal.classList.remove('rn-menu-warming');
    }
    if (!imgs.length) {
      portal.classList.remove('rn-menu-warming');
      return;
    }
    imgs.forEach(function (img) {
      var done = false;
      function once() {
        if (done) return;
        done = true;
        finish();
      }
      if (img.complete && img.naturalWidth > 0) {
        once();
        return;
      }
      img.addEventListener('load', once, { once: true });
      img.addEventListener('error', once, { once: true });
      if (typeof img.decode === 'function') {
        img.decode().then(once).catch(once);
      }
    });
    window.setTimeout(function () {
      portal.classList.remove('rn-menu-warming');
    }, 2500);
  }

  function warmDrawer() {
    if (state.warmed) return;
    state.warmed = true;
    ensurePortaled();
    measureHeaderOffset();
    var panel = getPanel();
    if (!panel) {
      state.warmed = false;
      return;
    }
    void panel.offsetWidth;
    // Idle warm — don't compete with first paint.
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(warmCircleImages, { timeout: 1200 });
    } else {
      window.setTimeout(warmCircleImages, 400);
    }
  }

  function enhance() {
    // Clear any stuck overflow locks from older builds — do not force-close an open menu.
    document.documentElement.classList.remove('rn-menu-scroll-lock');
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
    ensurePortaled();
    bindCaptureController();
    neutralizeDawn();
    warmDrawer();
  }

  window.RnMenuDrawer = {
    open: openDrawer,
    close: closeDrawer,
    reset: resetMenuPortalSafe,
  };

  // Only recover stuck state from bfcache — never on every normal load (that re-ran
  // portal work and made the page feel like it was constantly reloading).
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    try {
      resetMenuPortalSafe();
    } catch (err) {}
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('header-drawer').then(function () {
      // Header drawer already enhanced on DOMContentLoaded in most cases.
      if (!state.warmed) enhance();
      else neutralizeDawn();
    });
  }

  document.addEventListener('shopify:section:load', enhance);
})();
